import { CalendarEvent } from 'mini-calendar-event-types';
import { ColorScheme } from 'mini-color/lib/schema/ColorScheme';
import { getCalendarForCalendarEvent } from './getCalendarForCalendarEvent';
import { getColorSchemeForCalendar } from 'mini-calendar-color-resolver/lib/utils/calendarColorSchemeGenerator';
import { getCurrentThemeColorScheme } from 'mini-color/lib/utils/themeColorSchemeGenerator';
import { getPrimaryCategoryColorSchemeForEvent } from 'mini-categories/lib/api/getPrimaryCategoryColorSchemeForEvent';

/**
 * Function which gets the calendar color scheme of the calendar to which a particular event belongs
 * @param event
 */
export const getColorSchemeForCalendarEvent = (
    event: CalendarEvent,
    isDarkTheme: boolean
): ColorScheme => {
    let colorScheme: ColorScheme = null;
    if (event) {
        colorScheme = getPrimaryCategoryColorSchemeForEvent(event, isDarkTheme);
        if (!colorScheme) {
            const calendar = getCalendarForCalendarEvent(event);
            if (calendar) {
                colorScheme = getColorSchemeForCalendar(calendar, isDarkTheme);
            }
        }
    }

    return colorScheme || getCurrentThemeColorScheme();
};
